module.exports = __webpack_public_path__ + "img/krathong_5.a9f9d0cc.png";